// Paper-grain overlay (HOP-19). Every Hopscotch-brand screen gets one at
// 6% opacity over the paper ground — it's what makes the surface read as
// printed stock instead of a flat fill. Ported from the design handoff's
// Grain helper (specs/Hopscotch-UI-handoff/screens/motifs-frames.jsx).
//
// Place inside a `position: relative` container; it covers the container
// and never intercepts pointer events.

import { useId } from 'react';import { CssVarSvg } from "@/components/CssVarElements";

export function Grain({
  opacity = 0.06,
  blend = 'multiply'



}: {opacity?: number;blend?: 'multiply' | 'overlay';}) {
  const filterId = useId();
  return (
    <CssVarSvg
      cssVars={{
        position: 'absolute',
        inset: 0,
        width: '100%',
        height: '100%',
        pointerEvents: 'none',
        opacity,
        mixBlendMode: blend
      }}
      aria-hidden="true">

      <filter id={filterId}>
        <feTurbulence type="fractalNoise" baseFrequency="0.8" numOctaves="2" stitchTiles="stitch" />
      </filter>
      <rect width="100%" height="100%" filter={`url(#${filterId})`} />
    </CssVarSvg>);

}